import { useRef } from 'react';
import { useInitializationDataContext } from '../../../../context/data-context';
import { FabricTextBox } from '../../../../global-types';
import { useActiveCanvas, useIsSignAndSend } from '../../../../hooks';
import { CanvasDataTypes } from '../../../../utils';

export const useFontDrawerFlags = () => {
  const canvas = useActiveCanvas();
  const {
    initializedDataState: { isUK },
  } = useInitializationDataContext();
  const isSignAndSend = useIsSignAndSend();
  const lastFlags = useRef({ shouldShowColorEditor: false, shouldShowPositionTabEditor: false });

  try {
    const activeObject = canvas?.current?.getActiveObject() as FabricTextBox;

    if (!activeObject) {
      throw new Error('No active object found on canvas');
    }

    const shouldShowColorEditor: boolean =
      !!activeObject.CanEditFontColor ||
      activeObject.data.type === CanvasDataTypes.UserText ||
      !!(isUK && activeObject.data.type === CanvasDataTypes.Placeholder);

    const shouldShowPositionTabEditor = !isSignAndSend;

    lastFlags.current = { shouldShowColorEditor, shouldShowPositionTabEditor };
    return lastFlags.current;
  } catch (error) {
    return lastFlags.current;
  }
};
